import { render, staticRenderFns } from "./SentimentMarketHotDay.vue?vue&type=template&id=43f890b0&scoped=true"
import script from "./SentimentMarketHotDay.vue?vue&type=script&lang=js"
export * from "./SentimentMarketHotDay.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketHotDay.vue?vue&type=style&index=0&id=43f890b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f890b0",
  null
  
)

export default component.exports